import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from "react-toastify";
import LoadingAction from '../../../components/Loader';
import { useEditProductMutation } from '../../../Services/ProductApi';
import CategoryDropdown from './categoryDropdown';
const buttonWidth = {
    width: '100%'
};

const EditProduct = (props) => {
    const { refetchProducts, editData, setEditData, showEdit, handleClose, categories } = props;
    const [showLoader, setShowLoader] = useState(false);
    const [editProduct] = useEditProductMutation();
    const [prevCategoryIds, setPrevCategoryIds] = useState([]);
    const [deletedCategoryIds, setDeletedCategoryIds] = useState([]);
    const [newCategoryIds, setNewCategoryIds] = useState([]);
    useEffect(() => {
        console.log({ newCategoryIds, deletedCategoryIds })
    }, [newCategoryIds, deletedCategoryIds])
    const [formFields, setFormFields] = useState({
        name: '',
        description: '',
        recommended: false,
        hotSelling: false,
    });

    const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
    const [image, setImage] = useState([]);
    const [videos, setVideos] = useState([]);
    const [variants, setVariants] = useState([]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormFields(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const toggleCategorySelection = (categoryId) => {
        setSelectedCategoryIds(prev =>
            prev.includes(categoryId)
                ? prev.filter(id => id !== categoryId)
                : [...prev, categoryId]
        );
    };

    const handleImageChange = (event) => {
        const files = Array.from(event.target.files);
        const newImages = files.map(file => ({
            id: URL.createObjectURL(file),
            file,
            url: URL.createObjectURL(file),
        }));
        setImage(prev => [...prev, ...newImages]);
        event.target.value = '';
    };

    const handleVideoChange = (event) => {
        const files = Array.from(event.target.files);
        const newVideos = files.map(file => ({
            id: URL.createObjectURL(file),
            file,
            url: URL.createObjectURL(file),
        }));
        setVideos(prev => [...prev, ...newVideos]);
        event.target.value = '';
    };

    const handleDeleteImage = (id) => {
        setImage(prev => prev.filter(image => image.id !== id));
    };

    const handleDeleteVideo = (id) => {
        console.log({ id })
        setVideos(prev => prev.filter(video => video.id !== id));
    };

    const addVariantRow = () => {
        setVariants(prev => [...prev, { qty: '', price: '', rate: 0, description:"",customPrice:false }]);
    };

    const removeVariantRow = (index) => {
        setVariants(prev => prev.filter((_, i) => i !== index));
    };

    const handleVariantChange = (index, field, value, customPrice) => {
        console.log({ customPrice })
        const updated = variants.map((variant, i) => {
            if (i === index) {
                return { ...variant, [field]: value };
            }
            return variant;
        });
        // Calculate rate when price or qty changes
        if (!customPrice && (field === 'rate' || field === 'qty')) {
            console.log({ field, value, updated })
            const rate = field === 'rate' ? value : updated[index].rate;
            const qty = field === 'qty' ? value : updated[index].qty;
            updated[index].price = rate && qty ? rate * qty : '';
        }
        setVariants(updated);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formFields.name || selectedCategoryIds.length === 0) {
            toast.error("Product name and category are required.");
            return;
        }

        // Ensure rate is 0 if not filled
        const updatedVariants = variants.map(variant => ({
            ...variant,
            rate: variant.rate === '' || variant.rate === undefined || variant.rate === null ? 0 : variant.rate
        }));

        const formData = new FormData();
        formData.append('name', formFields.name);
        formData.append('description', formFields.description);
        formData.append('isRecommended', formFields.recommended);
        formData.append('isHotSelling', formFields.hotSelling);

        selectedCategoryIds.forEach((id, idx) => {
            if (!deletedCategoryIds.includes(id)) {
                formData.append(`categories[${idx}]`, id);
            }
        });
        deletedCategoryIds.forEach((id, idx) => {
            formData.append(`deletedCategoryIds[${idx}]`, id);

        });
        newCategoryIds.forEach((id, idx) => {
            formData.append(`newCategoryIds[${idx}]`, id);

        });
        if (!formFields.name) {
            toast.error("Name is required.");
            return;
        }
        if (selectedCategoryIds.length === 0) {
            toast.error("Atleast one category is required.");
            return;
        }
        if (!formFields.description) {
            toast.error("Description is required.");
            return;
        }
        if (image.length === 0) {
            toast.error("Atleast one image is required.");
            return;
        }
        if (variants.length === 0) {
            toast.error("Atleast one variant is required.");
            return;
        }
        console.log({ image })
        image.forEach((img, idx) => {
            if (img.file) {
                formData.append('image', img.file);
            } else {
                formData.append(`images[${idx}]`, img.id); // or 'images' if backend handles both
            }
        });
        videos.forEach((video, idx) => {
            if (video.file) {
                formData.append('video', video.file);
            } else {
                formData.append(`videos[${idx}]`, video.id); // or 'images' if backend handles both
            }
        });

        formData.append('variants', JSON.stringify(updatedVariants));

        setShowLoader(true);
        console.log({ idddd: editData.productId })
        try {
            const res = await editProduct({ productId: editData.productId, formData }).unwrap();
            toast.success("Product Updated Success !!");
            refetchProducts()
            handleClose();

        } catch (err) {
            toast.error(err?.data?.message || 'Something went wrong');
        } finally {
            setShowLoader(false);
        }
    };
    useEffect(() => {
        if (editData && showEdit) {
            setFormFields({
                name: editData.name || '',
                description: editData.description || '',
                recommended: editData.isRecommended || false,
                hotSelling: editData.isHotSelling || false,
            });
            setSelectedCategoryIds([editData.categories?.map(category => category._id)].filter(Boolean).flat());
            setPrevCategoryIds([editData.categories?.map(category => category._id)].filter(Boolean).flat())
            setImage(
                (editData.images || []).map((img, i) => ({
                    id: img,
                    file: null,
                    url:img,
                }))
            );
            setVideos(
                (editData.videos || []).map((vid, i) => ({
                    id: vid,
                    file: null,
                    url: vid,
                }))
            );
            setVariants(editData.variants || []);
        }
    }, [editData, showEdit]);
    const handleAddCustomPrice = (index, field, value) => {
        console.log({ value })
        const updated = variants.map((variant, i) => {
            if (i === index) {
                return { ...variant, [field]: value };
            }
            return variant;
        });
        setVariants(updated);
    };

    return (
        <Modal show={showEdit} onHide={handleClose} centered size="lg" scrollable>
            <Modal.Header closeButton className="border-0 mt-4 pt-0 pb-2">
                <div className="d-flex justify-content-center w-100">
                    <Modal.Title className='h4'>Edit Product</Modal.Title>
                </div>
            </Modal.Header>

            {showLoader && <LoadingAction />}

            <Modal.Body className='px-md-4'>
                <form onSubmit={handleSubmit} className="form-login n">
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Product Name (30 characters max)</label>
                            <input
                                type="text"
                                name="name"
                                maxLength="30"
                                value={formFields.name}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Enter Name"
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Categories</label>
                            <CategoryDropdown
                                categories={categories?.filter(Boolean)}
                                selectedCategoryIds={selectedCategoryIds}
                                prevState={prevCategoryIds}
                                toggleCategorySelection={toggleCategorySelection}
                                setDeletedCategoryIds={setDeletedCategoryIds}
                                setNewCategoryIds={setNewCategoryIds}
                            />
                        </div>



                        <div className="col-md-12 mb-3">
                            <label className="form-label">Description (150 characters max)</label>
                            <textarea
                                name="description"
                                rows={2}
                                maxLength="150"
                                className="form-control"
                                placeholder="Enter Description"
                                value={formFields.description}
                                onChange={handleChange}
                            ></textarea>
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Product Images</label>
                            <input
                                type="file"
                                className="form-control"
                                multiple
                                accept="image/*"
                                onChange={handleImageChange}
                            />
                            <div className="preview-container d-flex mt-2 flex-wrap gap-2">
                                {image.map(image => (
                                    <div className="position-relative" key={image.id}>
                                        <img src={image.url} alt="Preview" height={80} />
                                        <button type="button" className="btn btn-sm btn-danger position-absolute top-0 end-0" onClick={() => handleDeleteImage(image.id)}>
                                            <i className="bi bi-x"></i>
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Product Videos</label>
                            <input
                                type="file"
                                className="form-control"
                                multiple
                                accept="video/*"
                                onChange={handleVideoChange}
                            />
                            <div className="preview-container d-flex mt-2 flex-wrap gap-2">
                                {videos.map(video => (
                                    <div className="position-relative" key={video.id}>
                                        <video src={video.url} height={80} controls />
                                        <button type="button" className="btn btn-sm btn-danger position-absolute top-0 end-0" onClick={() => handleDeleteVideo(video.id)}>
                                            <i className="bi bi-x"></i>
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="col-md-12 d-flex gap-4 mb-3">
                            <div className="form-check form-switch">
                                <input className="form-check-input" type="checkbox" id="recommended" name="recommended" checked={formFields.recommended} onChange={handleChange} />
                                <label className="form-check-label" htmlFor="recommended">Recommended</label>
                            </div>
                            <div className="form-check form-switch">
                                <input className="form-check-input" type="checkbox" id="hotSelling" name="hotSelling" checked={formFields.hotSelling} onChange={handleChange} />
                                <label className="form-check-label" htmlFor="hotSelling">Hot Selling</label>
                            </div>
                        </div>

                        <div className="col-md-12 mb-3">
                            <label className="form-label">Quantity Variants</label>
                            <div className="table-responsive mobile-form-input-width">
                                <table className="table table-bordered text-nowrap">
                                    <thead>
                                        <tr>
                                            <th>Item Description</th>
                                            <th>Rate</th>
                                            <th>Qty</th>
                                            <th>Price</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {variants.map((variant, index) => (
                                            <tr key={index}>
                                                <td className='pb-4'>
                                                    <div className='d-flex justify-content-between align-items-center mb-1'>
                                                        <small style={{ color: "transparent" }} >description</small>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={variant.description}
                                                        onChange={(e) => handleVariantChange(index, 'description', e.target.value, variant.customPrice)}
                                                    />
                                                </td>
                                                <td className='pb-4'>
                                                    <div className='d-flex justify-content-between align-items-center mb-1'>
                                                        <small style={{ color: "transparent" }} >rate</small>
                                                    </div>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={variant.rate}
                                                        onChange={(e) => handleVariantChange(index, 'rate', e.target.value, variant.customPrice)}
                                                    />
                                                </td>

                                                <td className='pb-4'>
                                                    <div className='d-flex justify-content-between align-items-center mb-1'>
                                                        <small style={{ color: "transparent" }} >Qty</small>
                                                    </div>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={variant.qty}
                                                        onChange={(e) => handleVariantChange(index, 'qty', e.target.value, variant.customPrice)}
                                                    />
                                                </td>
                                                <td className='pb-4'>
                                                    <div className='d-flex justify-content-between align-items-center mb-1'>
                                                        <small className='text-muted' >Add Custom</small>
                                                        <input
                                                            type="checkbox"
                                                            className='form-check-input mt-0'
                                                            id='custom-price'
                                                            checked={variant.customPrice}
                                                            onChange={(e) => handleAddCustomPrice(index, 'customPrice', e.target.checked)} />
                                                    </div>
                                                    {variant.customPrice ? (<input
                                                        id="product-price"
                                                        type="number"
                                                        className="form-control"
                                                        value={variant.price}
                                                        onChange={(e) => handleVariantChange(index, 'price', e.target.value, variant.customPrice)}
                                                    />) :
                                                        (<input
                                                            id="product-price"
                                                            type="number"
                                                            className="form-control"
                                                            value={variant.price}
                                                            readOnly
                                                        />)}
                                                </td>
                                                <td className="text-center align-middle">
                                                    <button type="button" className="btn btn-sm btn-danger" onClick={() => removeVariantRow(index)}>
                                                        <i className="bi bi-trash3"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <button type="button" className="btn btn-outline-primary" onClick={addVariantRow}>+ Add Variant</button>
                        </div>

                        <div className="text-center mb-4">
                            <button
                                type="submit"
                                className="btn bg-button py-3 text-white"
                                style={buttonWidth}
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default EditProduct;
